import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingRequiredNIFPT: {
    id: 'charity.vetting.pt.required.nif',
    defaultMessage: 'The NIF is required.',
  },
  charityVettingWrongNifFormatNumberPT: {
    id: 'charity.vetting.pt.wrong.nif.format.number',
    defaultMessage: 'Invalid format. The NIF must contain 9 digits.',
  },
  charityVettingWrongNipcFormatNumberPT: {
    id: 'charity.vetting.pt.wrong.nipc.format.number',
    defaultMessage: 'Invalid format. The NIPC must contain 9 digits.',
  },
  charityVettingRequiredNIPCPT: {
    id: 'charity.vetting.pt.required.nipc',
    defaultMessage: 'The NIPC is required.',
  },
});
